import dayjs from 'dayjs';

const convertToCSV = (data: any[]) => {
  const csvRows = [];

  for (const row of data) {
    const values: any[] = [];
    for (const value of row) {
      values.push(value.replace(/"/g, '\\"'));
    }

    // only push values if there is at least one value that is not an empty string
    if (values.some((value: string) => value.trim() !== '')) {
      csvRows.push(values.join(','));
    }
  }

  return csvRows.join('\n');
};

export const preparedData = (tableId: string) => {
  const findTableInElement = (
    element: HTMLElement | Element
  ): HTMLElement | Element | null => {
    // Rekursiv nach <table>-Element suchen
    if (element.tagName === 'TABLE') {
      return element;
    } else {
      const children = element.children;
      for (let i = 0; i < children.length; i++) {
        const foundTable = findTableInElement(children[i]);
        if (foundTable) {
          return foundTable;
        }
      }
    }
    return null;
  };
  // Eltern-Div auslesen
  const parentDiv = document.getElementById(tableId);

  if (!parentDiv) {
    return [];
  }

  // Tabelle innerhalb des Eltern-Divs finden
  const table = findTableInElement(parentDiv);

  if (!table) {
    return [];
  }

  const rows = table.getElementsByTagName('tr');

  // daten in array schreiben
  const data: any[] = [];
  for (let i = 0; i < rows.length; i++) {
    const rowData = [];

    const headerCells = rows[i].getElementsByTagName('th');
    const normalCells = rows[i].getElementsByTagName('td');
    const cells = [...(headerCells as any), ...(normalCells as any)];

    for (let j = 0; j < cells.length; j++) {
      const innerHtml = cells[j].innerHTML;

      // check for fa-check
      if (innerHtml.includes('fa-check')) {
        rowData.push('X');
      } else {
        rowData.push(cells[j].textContent);
      }
    }
    if (rowData.length > 0) {
      data.push(rowData);
    }
  }

  return data;
};

export const downloadCSV = (name: string) => {
  const filteredData = preparedData(name);
  const csvData = convertToCSV(filteredData);

  const currentTimestamp = dayjs().format('YYYY-MM-DD_HH-mm-ss');

  const blob = new Blob([csvData], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = currentTimestamp + '_' + name + '.csv';
  link.click();
};

export const getNodeText = (node: any): any => {
  if (['string', 'number'].includes(typeof node)) return node;
  if (node instanceof Array) return node.map(getNodeText).join('');
  if (typeof node === 'object' && node) return getNodeText(node.props.children);
};
